<ui-bulk-action-bar
    #bulkActionBar
    formDialog
    (primaryButtonPressed)="bulkAction(bulkActionForm)"
    primaryButtonLabel="{{ 'payroll.deductions.save' | appTranslate }}"
    (closing)="bulkActionBar.open = false"
    [form]="bulkActionForm.form"
>
    <app-employee-deduction-bulk-form
        #bulkActionForm
        [selectionCount]="selectionCount"
    ></app-employee-deduction-bulk-form>
</ui-bulk-action-bar>

<app-common-bulk-select-payroll-employee-dialog
    #selectEmployees
    headerText="{{ 'payroll.deductions.assignEmployees' | appTranslate }}"
></app-common-bulk-select-payroll-employee-dialog>

<app-upload-csv style="display: none" (onFileUpload)="onCsvUpload($event)"></app-upload-csv>

<div class="page-container" [class.loading]="isLoading">
    <app-header [title]="deduction.name" [back]="true" [menuService]="payrollDeductionsMenuService">
        <div *ngIf="!route.snapshot.data.isPayrollPending" class="buttons">
            <ui-button type="ghost" (click)="onAssign()">{{
                'payroll.deductions.addRemoveEmployees' | appTranslate
            }}</ui-button>
            <ui-button
                type="ghost"
                class="apply-button"
                [matMenu]="csvImportDropdown"
                (menuClosed)="expandCSVImportDropdown = false"
                (menuOpened)="expandCSVImportDropdown = true"
                >{{ 'payroll.deductions.csvImport' | appTranslate }}
                <mat-icon *ngIf="!expandCSVImportDropdown" svgIcon="chevronDown"></mat-icon>
                <mat-icon *ngIf="expandCSVImportDropdown" svgIcon="chevronUp"></mat-icon>
                <mat-menu #csvImportDropdown>
                    <button mat-menu-item (click)="onCsvTemplateDownload()">
                        {{ 'payroll.deductions.downloadTemplate' | appTranslate }}
                    </button>
                    <button mat-menu-item (click)="onCsvUpload()">
                        {{ 'payroll.deductions.uploadTemplate' | appTranslate }}
                    </button>
                </mat-menu>
            </ui-button>
        </div>
    </app-header>

    <!-- Disabled Banner -->
    <ui-banner *ngIf="route.snapshot.data.isPayrollPending" class="margin-bottom-4" variant="warning">
        <p class="flag-content">{{ 'payroll.deductions.pendingPayrollNotice' | appTranslate }}</p>
    </ui-banner>

    <app-table
        #tableComponent
        [table]="table"
        (selectionChanged)="selectionChanged($event)"
        [readonly]="route.snapshot.data.isPayrollPending"
    >
        <div class="empty">
            <img style="max-width: 30%" src="/assets/illustrations/magnifying-glass.png" />
            <h2 class="ui centered header">{{ 'payroll.deductions.noEmployeesFound' | appTranslate }}</h2>
        </div>
    </app-table>
</div>
